import {
  House,
  Truck,
  User,
  SuitcaseSimple,
  Files,
  Receipt,
  GasPump,
  Wrench,
  Car,
  FileX,
  Handshake,
  Buildings,
  Desktop,
  Star,
  ListBullets,
  ChartLine,
} from 'phosphor-react'
const getMenu = () => {
  const common = [
    {
      name: 'Início',
      icon: <House color="#053C5E" size={30} />,
      route: '/inicio',
    },
  ]
  const data = {
    admin: [
      ...common,
      {
        name: 'Administradores',
        icon: <Desktop color="#053C5E" size={30} />,
        route: '/admin/admins',
      },
      {
        name: 'Empresas',
        icon: <Buildings color="#053C5E" size={30} />,
        route: '/admin/empresas',
      },
    ],
    manager: [
      ...common,
      {
        name: 'Entregas',
        icon: <Files color="#053C5E" size={30} />,
        route: '/gestor-entregas/entregas',
        subitems: [
          {
            name: 'Todas as entregas',
            icon: <Files color="#053C5E" size={30} />,
            route: '/gestor-entregas/entregas/todas',
          },
          {
            name: 'Entregas com problemas',
            icon: <FileX color="#053C5E" size={30} />,
            route: '/gestor-entregas/entregas/problemas',
          },
        ],
      },
      {
        name: 'Pedidos',
        icon: <Truck color="#053C5E" size={30} />,
        route: '/gestor-entregas/pedidos',
      },
      {
        name: 'Veículos',
        icon: <Car color="#053C5E" size={30} />,
        route: '/gestor-entregas/veiculos',
        subitems: [
          {
            name: 'Multas',
            icon: <Receipt color="#053C5E" size={30} />,
            route: '/gestor-entregas/veiculos/multas',
          },
          {
            name: 'Abastecimentos',
            icon: <GasPump color="#053C5E" size={30} />,
            route: '/gestor-entregas/veiculos/abastecimentos',
          },
          {
            name: 'Manutenções',
            icon: <Wrench color="#053C5E" size={30} />,
            route: '/gestor-entregas/veiculos/manutencoes',
          },
          {
            name: 'Cargas',
            icon: <Truck color="#053C5E" size={30} />,
            route: '/gestor-entregas/veiculos/cargas',
          },
        ],
      },
    ],
    company: [
      ...common,
      {
        name: 'Veículos',
        icon: <Truck color="#053C5E" size={30} />,
        route: '/empresa/veiculos',
      },
      {
        name: 'Motoristas',
        icon: <User color="#053C5E" size={30} />,
        route: '/empresa/motoristas',
        subitems: [
          {
            name: 'Listar motoristas',
            route: '/empresa/motoristas/listar',
            icon: <ListBullets color="#053C5E" size={30} />,
          },
          {
            name: 'Avaliações',
            icon: <Star color="#053C5E" size={30} />,
            route: '/empresa/motoristas/avaliacoes',
          },
        ],
      },
      {
        name: 'Estatísticas de entregas',
        icon: <ChartLine color="#053C5E" size={30} />,
        route: '/empresa/estatisticas',
      },
      {
        name: 'Atendentes',
        icon: <Handshake color="#053C5E" size={30} />,
        route: '/empresa/atendentes',
      },
      {
        name: 'Gestores de entregas',
        icon: <SuitcaseSimple color="#053C5E" size={30} />,
        route: '/empresa/gestores-entregas',
      },
      // {
      //   name: "Vendedores",
      //   icon: <Tag color="#053C5E" size={30} />,
      //   route: "/empresa/vendedores"
      // }
    ],
    attendant: [
      ...common,
      {
        name: 'Entregas',
        icon: <Files color="#053C5E" size={30} />,
        route: '/atendente/entregas',
      },
    ],
    driver: [...common],
    public: [...common],
  }
  return data
}

export default getMenu
